module.exports = __webpack_public_path__ + "media/ejw/ejwCameraIcon-b9baf4ae.png";